export default __webpack_public_path__ + "static/media/products_561.c4b44ccd.jpg";